import type { MouseEventHandler } from 'react';

import { Button } from '#/components/Button/Button';
import { useI18n } from '#/i18n/hooks/useI18n';
import { useCommentsStore } from '#/modules/cms/components/Comments/commentsStore';
import { trackClicked } from '#/utils/analytics/track/trackClicked';
import { scrollIntoView } from '#/utils/scrollIntoView';

// TODO: Fix this from eslint v9 update
// eslint-disable-next-line @typescript-eslint/require-await
const scrollToComments = async () => {
  const commentsEl = document.getElementById('openweb-container');
  if (!commentsEl) return;

  // NOTE: The sticky page header would cover the element if we used
  // Element.scrollIntoView, hence the offset.
  scrollIntoView(commentsEl, { padding: 100 });
  document.dispatchEvent(new CustomEvent('idealist-comments-request-focus'));
};

export function CommentButton() {
  const { i18n } = useI18n();

  const { isReady: isWidgetReady } = useCommentsStore();

  const handleCommentClick: MouseEventHandler<HTMLButtonElement> = (e) => {
    trackClicked('Comments CTA', { context: 'reactions_box' });
    // TODO: investigate why our Buttons don't lose focus on click
    e.currentTarget?.blur();
    scrollToComments();
  };

  return (
    <Button
      type="button"
      disabled={!isWidgetReady}
      onClick={handleCommentClick}
      qaId="comment-button"
      variant="secondary"
      icon={{ type: 'normalized', name: 'speech-bubble' }}
    >
      {i18n('Comment')}
    </Button>
  );
}
